import React from 'react';
import PropTypes from 'prop-types';
import SongStore from '../stores/SongStore';
import NoteDisplay from './NoteDisplay';
import SequenceSetNumberOfBarsAction from '../actions/SequenceSetNumberOfBarsAction';
import SequenceSetNameAction from '../actions/SequenceSetNameAction';
import SequenceSelectBarAction from '../actions/SequenceSelectBarAction';
import DeleteSequenceAction from '../actions/DeleteSequenceAction';

export default class NoteGrid extends React.Component {
    static propTypes = {
        name: PropTypes.string,
    };

    static contextTypes = {
        getStore: PropTypes.func.isRequired,
        executeAction: PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        var store = context.getStore(SongStore);

        this.state = {
            grid: store.getNoteGrid(),
            sequence: store.getSelectedSequence(),
            noteNames: store.song.getSelectedSequenceNoteNames(),
            beat: -1
        };

        store.on("NOTEGRID_GRID_UPDATE", () => {
            this.setState({
                grid: store.getNoteGrid()
            });
        });

        store.on("NOTEGRID_SEQUENCE_UPDATE", () => {
            this.setState({
                grid: store.getNoteGrid(),
                sequence: store.getSelectedSequence(),
                noteNames: store.song.getSelectedSequenceNoteNames()
            });
        });

        store.on("PLAY_SONG", () => {
            this.state.playing = true;
        });

        store.on("STOP_SONG", () => {
           this.state.playing = false;
        });

        store.on("BEAT_GRID_UPDATE_POSITION", (payload) => {
            if(this.state.playing) {
                if(this.state.sequence.number == payload.number && this.state.sequence.channel == payload.channel) {
                    this.setState({
                        beat: payload.beat
                    });
                } else {
                    this.setState({
                        beat: -1
                    });
                }

            }
        })

    }

    handleBarsChange(event) {
        this.context.executeAction(SequenceSetNumberOfBarsAction, {
            bars: event.target.value
        });
    }

    handleNameChange(event) {
        this.context.executeAction(SequenceSetNameAction, {
            name: event.target.value
        });
    }

    handleBarSelect(bar) {
        this.context.executeAction(SequenceSelectBarAction, {
            bar: bar
        });
    }

    handleSequenceDelete() {
        this.context.executeAction(DeleteSequenceAction, {
            sequence: this.state.sequence.number,
            channel: this.state.sequence.channel
        });
    }

    render() {

        var selects = [], className;

        for (var i = 0; i < this.state.sequence.bars; i++) {
            className = "bar" + ((this.state.sequence.selectedBar != i+1) ?"":" active") + (Math.floor(this.state.beat / 16) == i ?" playing":"");
            selects.push(<div className={className} onClick={this.handleBarSelect.bind(this, i+1)} key={i}/>)
        }

        return (
            <div className="NoteGrid">

                <header>
                    <select onChange={this.handleBarsChange.bind(this)} value={this.state.sequence.bars}>
                        <option value={1}>1 Bar</option>
                        <option value={2}>2 Bars</option>
                        <option value={4}>4 Bars</option>
                        <option value={8}>8 Bars</option>
                    </select>
                    <input type="text" placeholder="Name..." value={this.state.sequence.name} onChange={this.handleNameChange.bind(this)}/>
                    <div className="delete-button" onClick={this.handleSequenceDelete.bind(this)}>Delete</div>
                    <div className="bar-select">
                        {selects}
                    </div>
                </header>

                <NoteDisplay grid={this.state.grid} bar={this.state.sequence.selectedBar} beat={this.state.beat} names={this.state.noteNames}/>

            </div>
        );
    }
}
